interface Props {
  percent: number;
  height?: number;
  cyTag?: string;
}

export const LoadingBar = ({ percent, height = 4.5, cyTag }: Props) => {
  const label = `${percent}%`;
  const containerHeight = height * 0.25;
  const barHeight = (height - 1) * 0.25;
  const margin = 2;

  return (
    <div className="flex w-full justify-end items-center mt-2">
      <div className="w-full relative">
        <div
          className="w-full rounded-lg border border-primary-t-400"
          style={{ height: `${containerHeight}rem` }}
        />
        <div
          className="bg-primary-50 rounded-xl absolute"
          style={{
            width: `calc(${percent / 100} * (100% - ${margin * 2}px))`,
            height: `${barHeight}rem`,
            top: `${margin}px`,
            left: `${margin}px`,
          }}
        />
      </div>
      <div
        data-cy={cyTag}
        className="w-14 justify-start text-primary-50 text-sm font-semibold font-['Inter'] leading-5"
      >
        {label}
      </div>
    </div>
  );
};
